import React, { useContext } from 'react'
import { Button, Modal } from 'reactstrap'
import check from '../../assets/images/check.png'
import close from '../../assets/images/close.png'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import PropTypes from 'prop-types'
import { AppContext } from '../../context/AppContextProvider'
import { SalesType } from '../../util/constants'

const PurchaseComplete = (props) => {
  const { purchasedState } = useContext(MessageHandlerContext)
  const { salesType } = useContext(AppContext)

  const renderMessage = () => {
    return (
      <>
        <img src={!purchasedState ? close : check} /><br />
        {
          !purchasedState
            ? (<h6>Sorry something happened, please try again.</h6>)
            : (<h6>
              {
                (salesType === SalesType.SUBSCRIPTION) ? 'Subscription Successful.' : 'Purchase Successful.'
              }
            </h6>)
        }
        {props.iscollection
          ? (
          <Button color="warning" block onClick={() => navigateBack()}>
             More Lotteries
          </Button>
            )
          : (
          <Button color="warning" block onClick={() => processComplete()}>
            More Lotteries
          </Button>
            )}

      </>
    )
  }
  const navigateBack = () => {
    // Implemention for widget collection model close after clicking on more lotteries
    props.toggle()
  }

  const processComplete = () => {
    props.toggle()
    window.open(process.env.REACT_APP_CLIENT_PROXY_TRACKING_URL, '_blank')
  }

  return (
    <Modal isOpen={props.opened} toggle={props.toggle} backdrop="static">
      <div className="login_otp">
        <div className="login_otp_wrapper text-center">
          {
            renderMessage()
          }
        </div>
      </div>
    </Modal>
  )
}

PurchaseComplete.propTypes = {
  opened: PropTypes.bool,
  toggle: PropTypes.func,
  iscollection: PropTypes.bool
}

export default PurchaseComplete
